import { BaseGetRequest } from './core/baseGetRequest';
import { Authentication } from './core/baseRequest';
import {GiftsList, GiftsListDynamicType} from 'acscp/api/models/giftsList';

export class GiftsRequest extends BaseGetRequest<GiftsList> {
    constructor() {
        super('loyalty/gifts', {}, GiftsListDynamicType, Authentication.Login);
    }
}
